module.exports = __webpack_public_path__ + "static/media/appmobile6.3018c247.webp";